module.exports = __webpack_public_path__ + "img/t2-c12.49416951.png";